export default __webpack_public_path__ + "static/sharing-ce998d67e97c8f9aeea7e420a93940c9.png";